import { useEffect } from 'react'
import { v4 as uuidv4 } from 'uuid'

const setCookie = (name, value) => {
  document.cookie = `${name}=${value}; path=/; SameSite=None; Secure`
}

const getCookie = (name) => {
  const nameEQ = name + '='
  return (
    document.cookie
      .split(';')
      .map((c) => c.trim())
      .find((c) => c.startsWith(nameEQ))
      ?.substring(nameEQ.length) || null
  )
}

const App = () => {
  useEffect(() => {
    let permanentId = getCookie('permanent_id')

    if (!permanentId) {
      permanentId = uuidv4()
      setCookie('permanent_id', permanentId)
    }

    try {
      const iframeLocation = window.location.href
      const url = new URL(iframeLocation);
      const queryParams = new URLSearchParams(url.search);

      const origin = queryParams.get('origin');
      const id = queryParams.get('id');

      window.parent.postMessage(JSON.stringify({ permanent_id: permanentId, id }), origin)
    } catch (error) {
      console.error(error)
    }
  }, [])

  return (
    <></>
  );
}

export default App;
